import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'gatsby';
import kebabCase from 'lodash/kebabCase';
import * as styles from './Categories.module.scss';
import { toggleDrawer as toggleDrawerAction } from '../../../state/app';

const Categories = ({ categories, toggleDrawer }) => (
  <nav className={styles.categories}> 
    <h4 className={styles.categories__header}>カテゴリー</h4>
    <ul className={styles.categories__list}>
      {categories.map((category) => (
        <li className={styles.categories__list_item} key={category.fieldValue}>
          <Link className={styles.categories__list_item} to={`/category/${kebabCase(category.fieldValue)}/`} onClick={() => toggleDrawer(false)}>
            {category.fieldValue} ({category.totalCount})
          </Link>
        </li>
      ))}
    </ul>
  </nav>
);

export default connect(
  (state) => ({ isDrawerOpen: state.app.isDrawerOpen }),
  (dispatch) => ({ toggleDrawer: (open) => dispatch(toggleDrawerAction(open)) }),
)(Categories);
